import { useState, useEffect, useRef, useMemo } from 'react';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import useCachedImage from '../hooks/useCachedImage';

const ImageComponent = ({ imageUrl, fallbackUrl, maxH, maxW, objectF, h = "100%", w = "100%", cu = 'default', handleClick = null }) => {
  const [isInViewPort, setIsInViewPort] = useState(false);
  const { image, isError } = useCachedImage(
    isInViewPort && imageUrl ? imageUrl : null,
    isInViewPort ? fallbackUrl : null,
  );
  const imgRef = useRef(null);

  useEffect(() => {
      if (!imgRef.current) return;

      const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
              if (entry.isIntersecting) {
                  setIsInViewPort(true);
                  observer.disconnect();
              }
          });
      });

      observer.observe(imgRef.current);

      return () => observer.disconnect();
  }, []);

  const blobSrc = useMemo(() => image ? URL.createObjectURL(image) : null, [image]);
  useEffect(() => { return () => { if (blobSrc) URL.revokeObjectURL(blobSrc); }; }, [blobSrc]);

  if ((isError || !imageUrl) && !blobSrc) {
    return (
      <div ref={imgRef} style={{ maxHeight: maxH, maxWidth: maxW, width: w, height: h, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <BrokenImageIcon sx={{ color: '#bbb', fontSize: 40 }} />
      </div>
    );
  }

  return (
      <img
          ref={imgRef}
          src={blobSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"}
          alt=""
          style={{ maxHeight: maxH, maxWidth: maxW, display: 'block', objectFit: objectF, width: w, height: h, cursor: cu }}
          onClick={handleClick}
      />
  );
};

export default ImageComponent;
